import { Button, Container } from "reactstrap";
import styles from "./ViewCampaign.module.scss";
import Headphones from "../../../../../assets/images/product-image-headphones.png";
import BackButton from "../../../../../components/common/BackButton/BackButton";
import { useNavigate } from "react-router-dom";
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent";

const ViewCampaign = () => {
  const navigate = useNavigate();

  const data = [
    { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, campaignStock: "$33.33", price: 300 },
    { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, campaignStock: "$33.33", price: 300 },
    { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, campaignStock: "$33.33", price: 300 },
    { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, campaignStock: "$33.33", price: 300 },
    { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, campaignStock: "$33.33", price: 300 },
    { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, campaignStock: "$33.33", price: 300 },
    { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, campaignStock: "$33.33", price: 300 },
    { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, campaignStock: "$33.33", price: 300 },
  ];

  const columns = [
    {
      name: "Product Image",
      cell: (row) => (
        <img src={row.productImage} alt="" width={45} height={47} />
      ),
      minWidth: "140px",
    },
    {
      name: "Product Name",
      selector: (row) => row.name,
      minWidth: "140px",
    },
    {
      name: "Category",
      selector: (row) => row.category,
      minWidth: "120px",
    },
    {
      name: "SKU",
      selector: (row) => row.sku,
      minWidth: "120px",
    },
    {
      name: "Stock",
      selector: (row) => row.stock,
    },
    {
      name: "Compaign Stock",
      selector: (row) => row.campaignStock,
      minWidth: "160px",
    },
    {
      name: "Price",
      selector: (row) => row.price,
    },
  ];

  return (
    <div className={styles.mainContainer}>
      <BackButton />
      <div className={styles.submissionContainer}>
        <h5 className="fw-semibold mb-3">Product Submission for Campaign</h5>

        <div className={styles.addProductBtnContainer}>
          <Button
            type="button"
            color="primary"
            className={styles.productBtn}
            onClick={() => navigate("/marketing-options/campaigns/add-product")}
          >
            Add Products
          </Button>
        </div>

        <Container fluid className={`g-0 ${styles["wrapper"]}`}>
          <div className={styles["heading"]}>Added Product</div>
        </Container>
        <Container fluid className={`g-0 ${styles["table-wrapper"]}`}>
          <DatatableComponent
            data={data}
            columns={columns}
            type="gray"
            pagination
          />
        </Container>
      </div>
    </div>
  );
};

export default ViewCampaign;